var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.43118 5.73871L9.35196 4.98755L10.2727 4.23639C10.6604 3.92139 10.5716 3.63869 10.0708 3.61446L8.79465 3.54177L6.7754 3.42869L6.44424 2.5806L6.01616 1.46598L5.58808 0.35135C5.41038 -0.117117 5.11153 -0.117117 4.93384 0.35135L4.0696 2.57253L3.73844 3.42061L1.71919 3.53369L0.443025 3.60638C-0.057749 3.63061 -0.146596 3.91331 0.2411 4.22831L1.16188 4.97947L2.08266 5.73064L2.78536 6.3041L2.32497 8.04066L1.94535 9.48644C1.81612 9.97106 2.05843 10.1407 2.47843 9.87414L4.48153 8.58182L5.24077 8.08912L6 8.58182L7.00155 9.22798L8.0031 9.87414C8.42311 10.1407 8.66542 9.97106 8.53619 9.48644L8.15657 8.04066L7.69618 6.3041L8.39888 5.73064L8.43118 5.73871Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2Icon);
export default __webpack_public_path__ + "static/media/Star2Icon.ee38999704d888a6c88106b555e8cf6a.svg";
export { ForwardRef as ReactComponent };